// extracted by mini-css-extract-plugin
export default {"role":"styles_role__JuKvV"};